import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { TrackedMap } from 'tracked-built-ins';

export default class AssetUploaderService extends Service {
  // Services
  @service flashMessages;
  @service store;

  // Defaults
  @tracked dropdown = null;
  @tracked selectedFolderToUpload = null;
  history = new TrackedMap();

  // Actions
  addFile = (folder, file) => {
    this.selectedFolderToUpload = null;

    const newAsset = this.store.createRecord('asset', {
      assetFolderId: folder.value,
      headline: file.name,
    });

    this.dropdown?.actions.open();
    this.history.set(file.uuid, {
      file: file,
      asset: newAsset,
    });
  };

  saveFile = async (file) => {
    let item = this.history.get(file.uuid);

    try {
      item.asset.tmpAssetName = file.uploadPath;

      await item.asset.save();

      if (this.loadRecords) {
        this.loadRecords.perform();
      }
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  };

  showHint = (folder) => {
    this.selectedFolderToUpload = folder;
  };

  hideHint = () => {
    this.selectedFolderToUpload = null;
  };
}
